import React, { memo } from 'react';
export default memo(function TableButtons({ prefixCls, buttons, children }) {
    const buttonGroup = buttons.length ? (React.createElement("span", { className: `${prefixCls}-toolbar-button-group` }, buttons)) : null;
    if (buttonGroup || children) {
        return (React.createElement("div", { className: `${prefixCls}-toolbar` },
            buttonGroup,
            children));
    }
    return null;
});
